import React from 'react';
import { BRIEF_CREATIF_GUIDANCE } from '../../utils/kkpVenteBriefUtils';
import KkpBriefAttachmentsEditor from './KkpBriefAttachmentsEditor';
import { AppFormField, AppTextarea } from '../ui';

const KkpVenteBriefCreativeStep = ({
  value,
  onChange,
  venteId = null,
  piecesJointes = [],
  onPiecesJointesChange,
  onError,
}) => (
  <div>
    <div className="kkp-brief-guidance mb-3">
      <p className="kkp-brief-guidance__intro mb-2">
        Répondez librement en vous appuyant sur les points suivants :
      </p>
      <ul className="kkp-brief-guidance__list mb-0">
        {BRIEF_CREATIF_GUIDANCE.map((item) => (
          <li key={item.question}>
            <strong>{item.question}</strong>
            <span className="text-secondary-light"> — ex. {item.example}</span>
          </li>
        ))}
      </ul>
    </div>
    <AppFormField label="Brief créatif" htmlFor="kkp-brief-creatif">
      <AppTextarea
        id="kkp-brief-creatif"
        className="kkp-brief-creatif-field"
        rows={10}
        placeholder="Saisissez ici le brief en reprenant les points ci-dessus…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </AppFormField>
    <KkpBriefAttachmentsEditor
      venteId={venteId}
      piecesJointes={piecesJointes}
      onChange={onPiecesJointesChange}
      onError={onError}
    />
  </div>
);

export default KkpVenteBriefCreativeStep;
